import { Outlet } from "react-router-dom";
import { PageProps } from "../../models/routing.model";

const Settings = (props: PageProps) => {
	return <Outlet />;
};

export default Settings;
